import { SVGProps } from "react";

export function Venus({
  style,
  className,
  ...props
}: {
  style?: React.CSSProperties;
  className?: string;
} & SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      style={style}
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19 8.875C19 5.07812 15.8659 2 12 2C8.13409 2 5 5.07812 5 8.875C5 12.3531 7.63216 15.2188 11.0455 15.6797V17.3125H9.13636C8.61136 17.3125 8.18182 17.7344 8.18182 18.25C8.18182 18.7656 8.60938 19.1875 9.13636 19.1875H11.0455V21.0625C11.0455 21.582 11.475 22 12 22C12.525 22 12.9545 21.5801 12.9545 21.0625V19.1875H14.8636C15.3906 19.1875 15.8182 18.7676 15.8182 18.25C15.8182 17.7324 15.3906 17.3125 14.8636 17.3125H12.9545V15.6789C16.367 15.2188 19 12.3516 19 8.875ZM6.90909 8.875C6.90909 6.11797 9.19284 3.875 12 3.875C14.8072 3.875 17.0909 6.11797 17.0909 8.875C17.0909 11.632 14.8072 13.875 12 13.875C9.19205 13.875 6.90909 11.6328 6.90909 8.875Z"
        fill="black"
      />
    </svg>
  );
}
